<div [ngClass]="footerContainerCssClasses" class="
    d-flex
    flex-column flex-md-row
    align-items-center
    justify-content-between
  ">
  <!-- begin::Copyright  -->
  <div class="text-dark order-2 order-md-1">
    <span class="text-muted fw-bold me-2">{{ currentDateStr }} &copy;
      <span class="text-muted fw-bold"> SML</span>
      <span class="text-muted fw-bold"> | v.{{version}}</span>
    </span>

  </div>
  <!-- end::Copyright  -->

  <!-- begin::Nav  -->
  <ul class="menu menu-gray-600 menu-hover-primary fw-bold order-1">
    <li class="menu-item d-flex" *ngIf="translate.currentLang === 'it'">
      <a class="menu-link pe-0 pe-2 cursor-pointer text-hover-primary" style="display: inline; flex: inherit"
         href="https://istitutomedicolegale.it/" target="_blank">
        istitutomedicolegale.it </a>
      <a class="menu-link pe-0 pe-2 cursor-pointer text-hover-primary" style="display: inline; flex: inherit"
         href="https://api.soluzionemedicolegale.it/termini_condizioni.pdf" target="_blank">
        Termini e condizioni di utilizzo </a>
    </li>
    <li class="menu-item d-flex" *ngIf="translate.currentLang === 'es'">
      <a class="menu-link pe-0 pe-2 cursor-pointer text-hover-primary" style="display: inline; flex: inherit"
         href="https://solucionmedicolegal.es/" target="_blank">
        solucionmedicolegal.es </a>
      <a class="menu-link pe-0 pe-2 cursor-pointer text-hover-primary" style="display: inline; flex: inherit"
         href="https://api.solucionmedicolegal.es/termino_condiciones.pdf" target="_blank">
        Términos y condiciones de uso</a>
    </li>
  </ul>
  <!-- end::Nav  -->
</div>
